import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { RootState } from "redux/reducers";
import { searchDocuments } from "redux/actions/search";

import SortOptions from "./SortOptions";
import SearchResults from "./SearchResults";

import { generatePageTitle } from "utils/general.utils";

const Search = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useSelector((state: RootState) => state);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    document.title = generatePageTitle("Search");
  });

  useEffect(() => {
    setCategories([]);
  }, [search.query]);

  // Reports found in chapters or by name, each counted once
  const reportCount = new Set(
    search.results
      .map((report: any) => report.report_id)
      .concat((search.namedReports || []).map((report) => report.report_id))
  ).size;

  return (
    <Container>
      <SortOptions results={reportCount} categories={categories} />
      <Title>Search Results: "{search.correctedQuery || search.query}"</Title>
      {search.correctedQuery && (
        <SubText>No reports matched "{search.query}", so these are the results for "{search.correctedQuery}".</SubText>
      )}
      {search.suggestedQuery && (
        <SubText>
          Did you mean{" "}
          <SuggestionButton type="button" onClick={() => dispatch(searchDocuments({ query: search.suggestedQuery }, navigate))}>
            {search.suggestedQuery}
          </SuggestionButton>
          ?
        </SubText>
      )}
      <SubText>Your search was found in the following report(s):</SubText>
      <SearchResults categories={categories} setCategories={setCategories} />
    </Container>
  );
};

const Container = styled.div`
  background-color: #fff;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
  padding: 2rem;
  margin: 2rem auto;
  min-height: 100rem;
  max-width: 110rem;
`;

const Title = styled.h2`
  color: ${(props) => props.theme.colors.idataBlue};
  font-size: 3.5rem;
  margin-top: 2rem;
  margin-bottom: 2rem;
`;

const SubText = styled.p`
  font-size: 2.5rem;
  margin-top: 0;
`;

const SuggestionButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: ${(props) => props.theme.colors.idataBlue};
  text-decoration: underline;
  cursor: pointer;
`;

export default Search;
